<template>

	<div class="bkf7 gameall_list">
		<el-container>
			<div class="inter2">

				<div class="filter-sticky-box">
				<div class="filter_wbox">
					<div class="filter_wbox_list">
						<div class="item" :class="{ 'active': filter_chose[index].show_title != '' }"
							v-for="(item, index) in filterlist" @click="showfilter(index, item)">{{
								item.title }}</div>
					</div>
					<div class="filter_wbox_content" v-if="show_filter2">

						<div class="filter_wbox_list2" v-if="show_filter_content.type != 'selects'">
							<div class="item" :class="{ 'active': getItemActive(show_filter_content, item) }"
								v-if="item.value != ''" v-for="(item, index) in show_filter_content.content"
								@click="choseFilterItem(show_filter_content, item)">

								{{ item.title }}
							</div>
						</div>

						<div class="filter_wbox_list2" v-if="show_filter_content.type == 'selects'">
							<div class="item"
								:class="{ 'active': show_filter_selects[show_filter_content.name] && show_filter_selects[show_filter_content.name].value.includes(item.value) }"
								v-if="item.value != ''" v-for="(item, index) in show_filter_content.content"
								@click="choseFilterselects(show_filter_content, item)">
								{{ item.title }}
							</div>
							<div class="item item_btn" @click="choseFilterItem2(show_filter_content)">
								确认
							</div>
						</div>
					</div>
					<div class="filter_wbox_select">
						<div class="filter_wbox_list3">
							<div class="item" v-if="item.show_title != ''" v-for="(item, index) in filter_chose">

								<span class="sp1">{{ item.title }}:{{ item.show_title }}</span>
								<div class="ic" v-if="item.type != 'selects'">
									<i class="el-icon-circle-close" @click="removefilter(index)"></i>
								</div>
								<div class="ic" v-if="item.type == 'selects'">
									<i class="el-icon-circle-close" @click="removefilter2(index, item.name)"></i>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div class="filter-content" style="margin-bottom: 20px;">
					<div class="filter-content-map">

						<!-- <div class="filter-list filter-script-list">
							<div class="filter-script">



								<div class="filter-item">
									<div class="filter-item-label">大区</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="daquchange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == daqu }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="daquchange(item)"
													:class="{ 'opt-item_active': item.id == daqu }"
													v-for="item in channellist">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>


								<div class="filter-item" v-if="daqu != 0">
									<div class="filter-item-label">服务器</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="fuwqichange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == fuwuqi }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="fuwqichange(item)"
													:class="{ 'opt-item_active': item.id == fuwuqi }"
													v-for="item in server_list">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>

								<div class="filter-item" v-if="show_filter" v-for="(item, index) in filterlist">
									<div class="filter-item-label">{{ item.title }}</div>
									<div class="filter-item-content">
										<div class="filter-item-options"
											:class="{ 'filter-item-options_expand': show_list[item.name].show }">
											<div class="opt-list">
												<div class="opt-item" @click="choseFilter(index, item1.value)"
													:class="{ 'opt-item_active': item1.active }"
													v-for="item1 in item.content">
													<div class="opt-item-name ellipsis-2">
														{{ item1.title }}
													</div>
												</div>
											</div>

											<div class="opt-more"
												v-show="!show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												更多
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
											<div class="opt-more"
												v-show="show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												收起
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> -->
						<div class="filter-section" style="padding-top: 20px;">
							<div class="filter-section-label">区间搜索</div>
							<div class="filter-section-list">

								<div class="section-item">
									<div class="item-label">
										价格
									</div>
									<div class="item-field">
										<el-input v-model="filter.strprice" @change="strpricechange" placeholder="最低值">
										</el-input>
										<div class="line"></div>
										<el-input v-model="filter.endprice" @change="endpricechange" placeholder="最高值">
										</el-input>
									</div>
								</div>
							</div>
						</div>
						<div class="filter-keywords-search">
							<div class="filter-search-label">关键词</div>
							<div class="filter-search-info">
								<div class="filter-search-input el-input el-input--suffix">
									<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入关键字"
										class="el-input__inner"><span class="el-input__suffix">
										<span class="el-input__suffix-inner" @click="Search">
											<div class="search">搜索</div>
										</span></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>


				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<li :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>推荐排序</span></li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort)">
								<span>结算比例</span><span v-if="sortactive == 2 && sort == 0">↑</span><span
									v-if="sortactive == 2 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort)">
								<span>总资产</span><span v-if="sortactive == 3 && sort == 0">↑</span><span
									v-if="sortactive == 3 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 4 }" @click="chose_sort(4, sort)">
								<span>哈夫币</span><span v-if="sortactive == 4 && sort == 0">↑</span><span
									v-if="sortactive == 4 && sort == 1">↓</span>
							</li>
						</ul>


					</div>
				</el-row>



				<el-row v-if="isMobile">


					<div class="mobile_home_game" :key="mo_index">
						<div class="item" v-for="(item, index) in flowList">
							<div class="w_con1">
								<div class="wtext_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<p class="p1">{{ item.title }}</p>
										<p class="p2"> 商品编号：{{ item.id }} </p>
										<div class="p3">
											<div class="price1">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.price }}</span>
												<span class="sp3">租金</span>
											</div>
											<div class="price2">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.yajin }}</span>
												<span class="sp3">押金</span>
											</div>
										</div>
									</div>
								</div>
								<div class="wtext_2">
									<div class="text">
										<p class="p1">{{ item.zichan }}</p>
										<p class="p2">总资产(m)</p>
									</div>

									<div class="text">
										<p class="p1">{{ item.chunbi }}</p>
										<p class="p2">纯币资产(m)</p>
									</div>
									<div class="text">
										<p class="p1">{{ getFilterName('box', item.box) }}</p>
										<p class="p2">安全箱</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.awm }}</p>
										<p class="p2">AWM子弹</p>
									</div>

								</div>
								<div class="wtext_3">

									<div class="fl" @click="show(index)">
										账号详情 <div class="ic">

											<i class="el-icon-arrow-down" v-if="!item.show"></i>
											<i class="el-icon-arrow-up" v-if="item.show"></i>
										</div>
									</div>
									<div class="fr">
										<router-link class="sp1" :title="item.title" target="_blank"
											:to="{ path: '/goodsdetail', query: { id: item.id } }">
											立即租赁
										</router-link>

									</div>
								</div>
							</div>
							<div class="item-view-bottom-details" v-show="item.show">
								<div class="detail-series type1"> 游戏区服:{{ item.qufu == '2' ? '微信' : item.qufu == '1' ?
									'QQ' : '-' }} </div>
								<div class="detail-series type2"> 登录方式：{{ item.login_type == '1' || item.login_type == '扫码登录' ? '扫码登录' :
									item.login_type == '2' || item.login_type == '账号密码' ?
										'账号密码' : '-' }} </div>
								<div class="detail-series type3">段位：{{ getFilterName('duanwei', item.duanwei) }}</div>
								<div class="detail-series">总资产：{{ item.zichan }}</div>
								<div class="detail-series">账号等级：{{ item.level }}</div>
								<div class="detail-series">KD：{{ item.kd }}</div>
								<div class="detail-series">靶场等级：{{ item.bachang }}级</div>
								<div class="detail-series">训练等级：{{ item.xunlian }}</div>
								<div class="detail-series"> 封禁记录：{{ item.is_feng == '1' ? '无' : item.is_feng == '2' ?
									'有' : '-' }} </div>
								<div class="detail-series"> 人脸是否本人：{{ item.is_ben == '1' ? '是' : item.is_ben == '2' ?
									'否' : '-' }} </div>
								<div class="detail-series">常用登陆地：{{ item.changzhu }}</div>
								<div class="detail-series"> 账号类型：{{ item.leixing == '1' ? '纯币号' : item.leixing == '2' ?
									'纯币+物资' : '-' }} </div>
								<div class="detail-series">持有刀皮：{{ getFilterNameList('ganyuan', item.daopi)
								}}</div>
								<div class="detail-series">干员外观：{{ getFilterNameList('ganyuan', item.ganyuan)
								}}</div>

							</div>
						</div>

					</div>

					<!-- <div class="sanjiaozhou_list">

						<div class="item" v-for="(item, index) in flowList">
							<div class="text_1">
								<div class="fl">
									<div class="p1">编号:<span class="sp1">{{ item.id }}</span> </div>
									<div class="p1">发布时间:<span class="sp1">{{ formatDateToYmd(item.publishtime)
									}}</span> </div>
								</div>
								<div class="fr">
									<span class="sp1">{{ item.bili }}</span>
								</div>
							</div>
							<div class="text_2">
								<div class="show_text">
									<div class="p1">方便交易时间</div>
									<div class="p2">{{ item.jiaoyi }}</div>
								</div>
								<div class="show_text">
									<div class="p1">区服</div>
									<div class="p2">{{ item.qufu == '2' ? '微信' : item.qufu == '1' ? 'QQ' : '-' }}</div>
								</div>
								<div class="show_text">
									<div class="p1">登录方式</div>
									<div class="p2">{{ item.login_type == '1' || item.login_type == '扫码登录' ? '扫码登录' : item.login_type == '2' || item.login_type == '账号密码' ?
												'账号密码' : '-' }}</div>
								</div>
								<div class="show_text">
									<div class="p1">本人人脸</div>
									<div class="p2">	{{ item.is_ben == '1' ? '是' : item.is_ben == '2' ? '否' : '-' }}</div>
								</div>
								<div class="show_text">
									<div class="p1">段位</div>
									<div class="p2">{{ getFilterName('duanwei', item.duanwei) }}</div>
								</div>
								<div class="show_text">
									<div class="p1">总资产(m)</div>
									<div class="p2">{{ item.zichan }}</div>
								</div>
								<div class="show_text">
									<div class="p1">纯币资产(m)</div>
									<div class="p2">{{ item.chunbi }}</div>
								</div>
								<div class="show_text">
									<div class="p1">等级</div>
									<div class="p2">{{ item.level }}</div>
								</div>
								<div class="show_text">
									<div class="p1">训练等级</div>
									<div class="p2">{{ item.xunlian }}</div>
								</div>
								<div class="show_text">
									<div class="p1">靶场等级</div>
									<div class="p2">{{ item.bachang }}</div>
								</div>
								<div class="show_text">
									<div class="p1">安全箱</div>
									<div class="p2">{{ getFilterName('box', item.box) }}</div>
								</div>
								<div class="show_text">
									<div class="p1">AWP子弹</div>
									<div class="p2">{{ item.awm }}</div>
								</div>
								<div class="show_text">
									<div class="p1">刀皮</div>
									<div class="p2">{{ getFilterNameList('daopi', item.daopi)
											}}</div>
								</div>
								<div class="show_text">
									<div class="p1">干员皮</div>
									<div class="p2">{{ getFilterNameList('ganyuan', item.ganyuan)
											}}</div>
								</div>
								<div class="show_text">
									<div class="p1">价格</div>
									<div class="p2">{{ item.price }}</div>
								</div>
								<div class="show_text">
									<div class="p1">押金</div>
									<div class="p2">{{ item.yajin }}</div>
								</div>
								<div class="show_text">
									<div class="p1">仓库赠送</div>
									<div class="p2">{{ item.zengsong }}</div>
								</div>
								<div class="show_text">
									<div class="p1">号主禁止项</div>
									<div class="p2">{{ item.jingzhi }}</div>
								</div>
								<div class="show_text">
									<div class="p1">备注</div>
									<div class="p2">{{ item.beizhu }}</div>
								</div>
							</div>
							<div class="text_3">
								<router-link class="order-btn" :title="item.title" target="_blank"
									:to="{ path: '/goodsdetail', query: { id: item.id } }">
									下单
								</router-link>
							</div>
						</div>
					</div> -->
					<el-pagination class="pagebox" background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[10, 20, 30, 40, 50]" :page-size="10" layout="total, prev, pager, next"
						:total="total">
					</el-pagination>
				</el-row>


				<div class="zh_wcontent">
					<el-row v-if="!isMobile">


						<div v-show="loading" style="padding: 20px;" v-loading="loading" element-loading-text="加载中"
							element-loading-spinner="el-icon-loading">
							<el-skeleton :rows="6" animated />
						</div>

						<div class="my-table" v-if="!loading">
							<el-table :data="flowList" style="width: 100%">
								<el-table-column fixed="left" prop="id" label="编号">
								</el-table-column>
								<el-table-column prop="publishtime" width="100px" label="上架时间">
									<template slot-scope="scope">
										<span>
											{{ formatDateToYmd(scope.row.publishtime) }}
										</span>
									</template>
								</el-table-column>
								<el-table-column width="110px" prop="jiaoyi" label="方便交易时间">
								</el-table-column>
								<el-table-column prop="qufu" label="区服">
									<template slot-scope="scope">
										<span
											:class="scope.row.qufu === '2' ? 'color-wechat color-div' : 'color-qq color-div'">
											{{ scope.row.qufu == '2' ? '微信' : scope.row.qufu == '1' ? 'QQ' : '-' }}
										</span>
									</template>
								</el-table-column>
								<el-table-column width="100px" prop="login_type" label="登录方式">
									<template slot-scope="scope">
										<span
											:class="scope.row.login_type === '1' || scope.row.login_type === '扫码登录' ? 'color-sm color-div' : 'color-qq color-div'">
											{{ scope.row.login_type == '1' || scope.row.login_type == '扫码登录' ? '扫码登录' : scope.row.login_type == '2' || scope.row.login_type == '账号密码' ?
												'账号密码' : '-' }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="is_ben" label="本人人脸">
									<template slot-scope="scope">
										<span>
											{{ scope.row.is_ben == '1' ? '是' : scope.row.is_ben == '2' ? '否' : '-' }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="duanwei" label="段位">
									<template slot-scope="scope">
										<span>
											{{ getFilterName('duanwei', scope.row.duanwei) }}
										</span>
									</template>
								</el-table-column>
								<el-table-column width="120px" prop="zichan" label="总资产(m)">
									<template slot="header" style="display: flex;align-items: center;">
										<span>总资产(m)</span>
										<el-tooltip content="纯币资产单位 1M=100万" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>

								</el-table-column>
								<el-table-column width="120px" prop="chunbi" label="纯币资产(m)">
									<template slot="header" style="display: flex;align-items: center;">
										<span>纯币资产(m)</span>
										<el-tooltip content="纯币资产单位 1M=100万" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="bili" label="比例">
									<template slot="header" style="display: flex;align-items: center;">
										<span>比例</span>
										<el-tooltip content="以1：40为例，表示1元=40万哈夫币" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="level" label="等级">
									<template slot-scope="scope">
										<span>
											{{ scope.row.level }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="xunlian" label="训练等级">
									<template slot-scope="scope">
										<span>
											{{ scope.row.xunlian }}级
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="bachang" label="靶场等级">
									<template slot-scope="scope">
										<span>
											{{ scope.row.bachang }}级
										</span>
									</template>
								</el-table-column>
								<el-table-column width="130px" prop="box" label="安全箱">
									<template slot-scope="scope">
										<span class="color-sm color-div" :class="['color-div_box' + scope.row.box]">
											{{ getFilterName('box', scope.row.box) }}
										</span>
									</template>
								</el-table-column>
								<el-table-column width="100px" prop="awm" label="AWM子弹">

								</el-table-column>
								<el-table-column prop="daopi" label="刀皮">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark"
											:content="getFilterNameList('daopi', scope.row.daopi)" placement="left">
											<span class="sp_text"> {{ getFilterNameList('daopi', scope.row.daopi)
											}}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column prop="ganyuan" label="干员皮">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark"
											:content="getFilterNameList('ganyuan', scope.row.ganyuan)" placement="left">
											<span class="sp_text"> {{ getFilterNameList('ganyuan', scope.row.ganyuan)
											}}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column prop="wuqi" label="武器皮">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark"
											:content="getFilterNameList('wuqi', scope.row.wuqi)" placement="left">
											<span class="sp_text"> {{ getFilterNameList('wuqi', scope.row.wuqi)
											}}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column prop="price" label="价格(元)">

								</el-table-column>
								<el-table-column prop="yajin" label="押金(元)">

								</el-table-column>
								<el-table-column prop="image" label="图片">
									<template slot-scope="scope">
										<div class="game_item_image">
											<img :src="fixImageUrl(scope.row.image)" @click="openShowImg(fixImageUrl(scope.row.image))"></img>
										</div>

									</template>
								</el-table-column>
								<el-table-column prop="zengsong" label="号主赠送">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark" :content="scope.row.zengsong"
											placement="left">
											<span class="sp_text"> {{ scope.row.zengsong }}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column prop="beizhu" label="备注">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark" :content="scope.row.beizhu"
											placement="left">
											<span class="sp_text"> {{ scope.row.beizhu }}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column width="110px" prop="jingzhi" label="号主禁止项">
									<template slot-scope="scope">

										<el-tooltip class="item" effect="dark" :content="scope.row.jingzhi"
											placement="left">
											<span class="sp_text"> {{ scope.row.jingzhi }}</span>
										</el-tooltip>

									</template>
								</el-table-column>
								<el-table-column align="center" fixed="right" width="110px" label="操作">
									<template slot-scope="scope">
										<div class="order-btn-box">
											<router-link class="order-btn" :title="scope.row.title" target="_blank"
												:to="{ path: '/goodsdetail', query: { id: scope.row.id } }">
												下单
											</router-link>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>





						<el-pagination class="pagebox" background @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="current_page"
							:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>

					</el-row>
				</div>
			</div>
		</el-container>
		<el-dialog :visible.sync="image_show" :center="true" width="500px" destroy-on-close @closed="visible3 = false">
			<div class="image_show_box">
				<img :src="fixImageUrl(img_src)">
			</div>
		</el-dialog>
	</div>

</template>
<script>
export default {
	data() {
		return {
			query: [],
			daqu_list: [],
			server_list: [],
			server_show: false,
			channel: 30,
			daqu: 0,
			fuwuqi: 0,
			order: 1,
			flowList: [],
			filter_chose: [],
			filterlist: [],
			fbeifen: [],
			channeldata: [],
			current_page: 1,
			pagesize: 10,
			total: 0,
			last_page: 0,
			filter: {
				strprice: '',
				endprice: '',
			},
			loadStatus: 'loadmore',
			strprice: '',
			endprice: '',
			keyword: '',
			sortactive: 1,
			sort: 0,
			is_zu: 0,
			acc_type: "1",
			loading: true,
			priceindex: -1,
			q: "",
			pricelist: [{
				min: 500,
				max: 4999
			},
			{
				min: 5000,
				max: 9999
			},
			{
				min: 10000,
				max: 14999
			},
			{
				min: 15000,
				max: 19999
			},
			{
				min: 20000,
				max: 9999999
			}
			],
			channellist: [],
			flag: [],
			show_list: {},
			first: true,
			show_filter: true,
			show_filter2: false,
			show_filter_index: 0,
			show_filter_content: {},
			show_filter_selects: {},
			mo_index: 0,
			image_show: false,
			img_src: ''



		}
	},
	computed: {


		login() {
			return this.$store.getters.login
		},
		open_login() {
			return this.$store.getters.open_login
		},

		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		config() {
			return this.$store.getters.config
		},
		userinfo() {
			return this.$store.getters.userinfo
		}
	},
	created: function (data) {

		this.filter_chose2 = []
		this.keyword = this.$route.query.keyword;
		this.channel = 30;
		this.getchannellist(this.$data.channel);
		this.addRandomData(this.$data.channel, this.$data.current_page);

		// this.getFilterList()

	},
	watch: {
		$route() {

			this.$data.keyword = this.$route.query.keyword;
			this.$data.current_page = 1;
			this.$data.pagesize = 10;
			this.addRandomData(this.$data.channel, this.$data.current_page);

			// this.getFilterList()
		}
	},
	methods: {
		openShowImg(img) {
			this.img_src = img
			this.image_show = true
		},

		choseFilterselects(data, item) {

			const filterKey = data.name;
			// 1. 容错：如果 show_filter_selects[filterKey] 不存在，先初始化（关键！保证响应式）
			if (!this.show_filter_selects[filterKey]) {
				this.$set(this.show_filter_selects, filterKey, {
					value: [],
					title: []
				});
			}

			// 2. 取出数组（确保是响应式数组）
			const valueArray = this.show_filter_selects[filterKey].value;
			const valueArray2 = this.show_filter_selects[filterKey].title;
			const targetValue = item.value;
			const targetValue2 = item.title;

			// 3. 安全校验：确保是数组（避免调用 includes/splice 报错）
			if (!Array.isArray(valueArray) || !Array.isArray(valueArray2)) {
				this.$set(this.show_filter_selects[filterKey], 'value', []);
				this.$set(this.show_filter_selects[filterKey], 'title', []);
				return; // 初始化后退出，避免后续操作报错
			}

			// 4. 增删逻辑（splice/push 是 Vue2 支持的响应式数组方法）
			if (valueArray.includes(targetValue)) {
				const valIndex = valueArray.indexOf(targetValue);
				const titleIndex = valueArray2.indexOf(targetValue2);
				// 移除时要判断索引有效（避免 -1 导致删除最后一个元素）
				if (valIndex > -1) valueArray.splice(valIndex, 1);
				if (titleIndex > -1) valueArray2.splice(titleIndex, 1);
			} else {
				valueArray.push(targetValue);
				valueArray2.push(targetValue2);
			}



		},

		choseFilterItem2(item) {
			for (let i = 0; i < this.filter_chose.length; i++) {
				if (this.filter_chose[i].name == item.name) {
					this.filter_chose[i].value = [];
					this.filter_chose[i].value = this.show_filter_selects[item.name].value;
					this.filter_chose[i].show_title = this.show_filter_selects[item.name].title.join('/');;
					this.show_filter2 = false
					this.current_page = 1;
					this.pagesize = 10;
					this.addRandomData(this.channel, this.current_page);
				}
			}
		},

		//获取状态
		getItemActive(data, item) {
			for (let i = 0; i < this.filter_chose.length; i++) {
				if (this.filter_chose[i].name == data.name && this.filter_chose[i].show_title != '') {

					return this.filter_chose[i].value.includes(item.value)
				}
			}
		},
		//清空筛选
		removefilter(i) {
			this.filter_chose[i].value = [];
			this.filter_chose[i].show_title = '';
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},
		//清空筛选
		removefilter2(i, name) {
			this.$set(this.show_filter_selects, name, {
				value: [],
				title: []
			});

			this.filter_chose[i].value = [];

			this.filter_chose[i].show_title = '';
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},
		showfilter(index, item) {
			this.show_filter_index = index
			this.show_filter2 = true
			this.show_filter_content = item
		},


		choseFilterItem(item, data) {
			if (item.type != 'selects') {
				for (let i = 0; i < this.filter_chose.length; i++) {
					if (this.filter_chose[i].name == item.name) {
						this.filter_chose[i].value = [];
						this.filter_chose[i].value = [data.value];
						this.filter_chose[i].show_title = data.title;
						this.show_filter2 = false
						this.current_page = 1;
						this.pagesize = 10;
						this.addRandomData(this.channel, this.current_page);
					}
				}
			}

		},
		/**
		 * 去除时间字符串中的时分秒，只保留年月日
		 * @param {string} timeStr - 包含时分秒的时间字符串，如 "2026-01-15 16:20:31"
		 * @returns {string} 只保留年月日的字符串，如 "2026-01-15"
		 */
		formatDateToYmd(timeStr) {
			// 先判断输入是否有效，避免报错
			if (!timeStr || typeof timeStr !== 'string') {
				return ''; // 或返回默认值，如 '1970-01-01'
			}
			// 按空格分割，取第一个部分（年月日）
			return timeStr.split(' ')[0];
		},
		Search() {
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},
		openShow(name) {
			this.show_filter = false
			this.show_list[name].show = !this.show_list[name].show
			this.show_filter = true
		},
		choseFilter(index, value) {


			var type = this.filterlist[index].type

			if (value == '') {
				this.filter_chose[index].value = [value];
				this.current_page = 1;
				this.pagesize = 10;
				this.addRandomData(this.channel, this.current_page);
				return;
			}

			if (type == 'selects') {
				if (value != '') {
					let res = this.filter_chose[index].value.indexOf('');

					if (res !== -1) {
						// 存在则删除该值
						this.filter_chose[index].value.splice(res, 1);
					}
				}

				let res = this.filter_chose[index].value.indexOf(value);
				if (res !== -1) {
					// 存在则删除该值
					this.filter_chose[index].value.splice(res, 1);
				} else {
					// 不存在则添加该值
					this.filter_chose[index].value.push(value);
				}
			} else {
				this.filter_chose[index].value = [];
				this.filter_chose[index].value = [value];
			}


			console.log(this.filter_chose[index])
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},

		chose_sort(index, sort) {
			this.sortactive = index;

			if (sort == 0) {
				this.sort = 1
			} else {
				this.sort = 0
			}



			this.$data.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);


		},

		getchannellist(id) {
			this.rq.requests.post("/api/game/Hall/getchannellist", {
				id: id,

			}).then(res => {

				this.channellist = res.data;
			}).catch(error => {

			})
		},




		addRandomData(id, current_page, pagesize) {
			this.loading = true;
			var that = this;
			var filter = {};
			filter = this.$data.filter;
			filter.q = this.$data.key;



			filter.filter_chose = that.filter_chose,

				filter = JSON.stringify(filter);
			filter = encodeURIComponent(filter);



			this.rq.requests.post("api/game/hall/getCarchives", {
				id: id,
				daqu: that.daqu,
				fuwuqi: that.fuwuqi,
				page: current_page,
				filter: filter,
				order: that.sortactive,
				order_num: that.sort,
				pagesize: that.pagesize,
				keyword: that.keyword,

			}).then(res => {
				that.last_page = res.data.list.last_page;

				that.filter_chose = res.data.filter;
				that.filterlist = res.data.filterlist;
				that.current_page = res.data.list.current_page;
				that.total = res.data.list.total;

				for (let i = 0; i < that.filterlist.length; i++) {

					if (!that.show_list[that.filterlist[i].name]) {
						that.show_list[that.filterlist[i].name] = {
							show: that.filterlist[i].show,
							extend: that.filterlist[i].extend

						};


					}
				}




				that.flowList = res.data.list.data;

				for (let index = 0; index < that.flowList.length; index++) {
					that.flowList[index].show = false;

				}
				that.loading = false
				that.flag = res.data.flag;

			}).catch(error => {

			})
		},

		handleSizeChange(val) {

			this.pagesize = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, val);
		},
		handleCurrentChange(val) {
			this.current_page = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		strpricechange() {

			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		endpricechange() {
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		//选择大区
		daquchange(value) {

			if (value.id == 0) {
				this.server_list = [];

			} else {
				this.server_list = value.childlist
			}

			this.fuwuqi = 0;

			this.daqu = value.id;
			this.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);


		},
		//选择服务器
		fuwqichange(value) {

			this.fuwuqi = value.id;
			this.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		show(index) {

			this.flowList[index].show = !this.flowList[index].show
			this.mo_index++

		},

		getFilterName(value, num) {

			for (let i = 0; i < this.filterlist.length; i++) {
				if (this.filterlist[i].name == value) {

					for (let a = 0; a < this.filterlist[i].content.length; a++) {

						if (num == this.filterlist[i].content[a].value) {
							return this.filterlist[i].content[a].title

						}
					}
				}
			}
		},
		getFilterNameList(fieldName, valueStr) {
			// 1. 处理空值情况
			if (!valueStr || valueStr.trim() === '') {
				return ''; // 无值时返回"全部"
			}

			// 2. 找到对应字段的数据项
			const fieldItem = this.filterlist.find(item => item.name === fieldName);
			if (!fieldItem) {
				return ''; // 字段不存在时返回空字符串
			}

			// 3. 拆分值字符串为数组，并处理类型转换（匹配数据中的value类型）
			const values = valueStr.split(',').map(val => {
				// 尝试转换为数字（因为数据中value有数字类型，如1、2）
				const numVal = Number(val);
				return isNaN(numVal) ? val : numVal;
			});

			// 4. 匹配对应的中文标题
			const titles = [];
			fieldItem.content.forEach(contentItem => {
				if (values.includes(contentItem.value)) {
					titles.push(contentItem.title);
				}
			});

			// 5. 拼接并返回结果
			return titles.join(',');
		}

	}
}
</script>
<style>
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #508aff;
	background: #508aff;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #508aff;
}

.filter-sticky-box {
	position: sticky;
	top: 60px;
	z-index: 1;
	background: #fff;
}
</style>